import React from "react";
import { useAuth } from "../../provider/AuthProvider";
import UseTitle from "../../components/useTitle";
import "./SpellTemplateFull.scss";

const SpellTemplateFull = ({ spellTemplate, setIsUpdate, setIsDelete }) => {
  // Définition du titre de la page
  UseTitle("Sort " + (spellTemplate?.name || ""));

  const { isAdmin } = useAuth();

  return (
    <>
      <div className="spell-template-full">
        <h1>{spellTemplate.name}</h1>

        <div className="section">
          <h3>Informations générales</h3>
          <p className="element">Domaine : {spellTemplate.domain}</p>
          <p className="element">Portée : {spellTemplate.range}</p>
          <p className="element">Durée : {spellTemplate.duration}</p>
          <p className="element">Catalyseur : {spellTemplate.catalyst}</p>
          <p className="element">Coût : {spellTemplate.pm} PM</p>
          <p className="element">
            <em>Description : {spellTemplate.description || "-"}</em>
          </p>
        </div>

        <div className="section">
          <h3>Attributs</h3>
          <ul className="element">
            {spellTemplate.attributes.map((attribute) => (
              <li key={attribute.id}>{attribute.full_name}</li>
            ))}
          </ul>
        </div>

        <div className="section">
          <h3>Informations complémentaires</h3>

          <p className="element">
            Valeur de départ : {spellTemplate.value_start}
          </p>
          <p className="element">
            Pour la battaille : {(spellTemplate.for_battle && "Oui") || "Non"}
          </p>
          <p className="element">
            Activé par defaut :{" "}
            {(spellTemplate.is_active_default && "Oui") || "Non"}
          </p>
        </div>

        {isAdmin && (
          <div className="buttons">
            <button className="bt" onClick={() => setIsUpdate(true)}>
              Modifier
            </button>
            <button className="bt" onClick={() => setIsDelete(true)}>
              Supprimer
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default SpellTemplateFull;
